
import React from "react";

export default function Navbar() {
    return (
        <nav className="z-20 sticky top-0 backdrop-blur-sm backdrop-brightness-50 w-full flex flex-wrap p-5 justify-around md:flex-row items-center" >
            <a href="#about" className="title-font font-medium text-white  sm:grid hidden  ">
                Kalpak Chakraborty
            </a>
            <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 	flex flex-wrap items-center text-base justify-center">
                <a href="#projects" className="mr-5 transition-all hover:text-white">
                    Projects
                </a>
                <a href="#skills" className="mr-5 transition-all hover:text-white">
                    Skills
                </a>
                <a href="https://drive.google.com/drive/folders/1qx2MuQEVhgJgJ6HsnlvYYCUuFOgpP_fH?usp=sharing" target="_blank" rel="noreferrer" className="mr-5 hover:text-white">
                    Resume
                </a>
            </nav>
            <div className=" grid items-center ">
                <a href="#contact" className="inline-flex transition-all items-center hover:scale-105 hover:text-white border-0 py-1 px-3 focus:outline-none rounded text-base ">
                    Hire Me
                    <i className="fa-solid fa-arrow-right-long ml-2"></i>
                </a>
            </div>
        </nav>

    );
}
